/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable global-require */

import domReady from 'domready';
import search from './frontpage-search';
import mobileModalWrapper from './mobile-modal-wrapper';

function globalSearch(ele, apiUrl, finnBaseUrl, isMobile, shadowRoot) {
    const client = 'WEB';

    if (isMobile) {
        mobileModalWrapper(
            ele,
            (wrappedEle) => {
                search(wrappedEle, apiUrl, finnBaseUrl, client, shadowRoot);
            },
            shadowRoot,
        );
    } else {
        search(ele, apiUrl, finnBaseUrl, client, shadowRoot);
    }
}

export const globalSearchMobile = (ele, apiUrl, finnBaseUrl) =>
    globalSearch(ele, apiUrl, finnBaseUrl, true);
export const globalSearchDesktop = (ele, apiUrl, finnBaseUrl) =>
    globalSearch(ele, apiUrl, finnBaseUrl, false);

domReady(() => {
    // Polyfill Declarative Shadow DOM
    // Read more, https://web.dev/declarative-shadow-dom/#polyfill
    (function attachShadowRoots(root) {
        root.querySelectorAll('template[shadowroot]').forEach((template) => {
            const mode = template.getAttribute('shadowroot');
            const shadowRoot = template.parentNode.attachShadow({ mode });
            shadowRoot.appendChild(template.content);
            template.remove();
            attachShadowRoots(shadowRoot);
        });
    })(document);

    const sdom = document.querySelector(
        'legacy-troika-styling-wrapper',
    ).shadowRoot;

    const ele = sdom.getElementById('global-search');
    const apiUrl = ele.getAttribute('data-base-url') || 'https://www.finn.no';
    const finnBaseUrl =
        ele.getAttribute('data-finnbase-url') || 'https://www.finn.no';
    globalSearch(
        ele,
        apiUrl,
        finnBaseUrl,
        ele.getAttribute('data-is-mobile') === 'true',
        sdom,
    );
});
